import {
    RESET_DASHBOARD,
    ACA_DASHBOARD_COACH,
    ACA_DASHBOARD_COACH_SUCCESS,
    ACA_DASHBOARD_COACH_ERROR,
    ACA_DASHBOARD_PLAYER,
    ACA_DASHBOARD_PLAYER_SUCCESS,
    ACA_DASHBOARD_PLAYER_ERROR,
    ACA_DASHBOARD_BOWLER,
    ACA_DASHBOARD_BOWLER_SUCCESS,
    ACA_DASHBOARD_BOWLER_ERROR,
    ACA_DASHBOARD_BATWK,
    ACA_DASHBOARD_BATWK_SUCCESS,
    ACA_DASHBOARD_BATWK_ERROR,
    ACA_DASHBOARD_ALLR,
    ACA_DASHBOARD_ALLR_SUCCESS,
    ACA_DASHBOARD_ALLR_ERROR
} from '../constants/ActionTypes';

const INIT_DASHBOARD_STATE = {
    acaDashboardCoachStates: null,
    acaDashboardCoachLoader: false,
    acaDashboardCoachError: null,

    acaDashboardPlayerStates: null,
    acaDashboardPlayerLoader: false,
    acaDashboardPlayerError: null,

    acaDashboardBowlerStates: null,
    acaDashboardBowlerLoader: false,
    acaDashboardBowlerError: null,

    acaDashboardBatwkStates: null,
    acaDashboardBatwkLoader: false,
    acaDashboardBatwkError: null,

    acaDashboardAllrStates: null,
    acaDashboardAllrLoader: false,
    acaDashboardAllrError: null,
}

export default (state = INIT_DASHBOARD_STATE, action) => {
    switch (action.type) {
        case RESET_DASHBOARD: {
            return {
                ...INIT_DASHBOARD_STATE
            }
        }

        case ACA_DASHBOARD_COACH: {
            return {
                ...state,
                acaDashboardCoachLoader: true
            }
        }
        case ACA_DASHBOARD_COACH_SUCCESS: {
            return {
                ...state,
                acaDashboardCoachStates: action.payload,
                acaDashboardCoachLoader: false,
                acaDashboardCoachError: null
            }
        }
        case ACA_DASHBOARD_COACH_ERROR: {
            return {
                ...state,
                acaDashboardCoachError: action.payload,
                acaDashboardCoachLoader: false
            }
        }

        case ACA_DASHBOARD_PLAYER: {
            return {
                ...state,
                acaDashboardPlayerLoader: true
            }
        }
        case ACA_DASHBOARD_PLAYER_SUCCESS: {
            return {
                ...state,
                acaDashboardPlayerStates: action.payload,
                acaDashboardPlayerLoader: false,
                acaDashboardPlayerError: null
            }
        }
        case ACA_DASHBOARD_PLAYER_ERROR: {
            return {
                ...state,
                acaDashboardPlayerError: action.payload,
                acaDashboardPlayerLoader: false
            }
        }

        case ACA_DASHBOARD_BOWLER: {
            return {
                ...state,
                acaDashboardBowlerLoader: true
            }
        }
        case ACA_DASHBOARD_BOWLER_SUCCESS: {
            return {
                ...state,
                acaDashboardBowlerStates: action.payload,
                acaDashboardBowlerLoader: false,
                acaDashboardBowlerError: null
            }
        }
        case ACA_DASHBOARD_BOWLER_ERROR: {
            return {
                ...state,
                acaDashboardBowlerError: action.payload,
                acaDashboardBowlerLoader: false
            }
        }

        case ACA_DASHBOARD_BATWK: {
            return {
                ...state,
                acaDashboardBatwkLoader: true
            }
        }
        case ACA_DASHBOARD_BATWK_SUCCESS: {
            return {
                ...state,
                acaDashboardBatwkStates: action.payload,
                acaDashboardBatwkLoader: false,
                acaDashboardBatwkError: null
            }
        }
        case ACA_DASHBOARD_BATWK_ERROR: {
            return {
                ...state,
                acaDashboardBatwkError: action.payload,
                acaDashboardBatwkLoader: false
            }
        }

        case ACA_DASHBOARD_ALLR: {
            return {
                ...state,
                acaDashboardAllrLoader: true
            }
        }
        case ACA_DASHBOARD_ALLR_SUCCESS: {
            return {
                ...state,
                acaDashboardAllrStates: action.payload,
                acaDashboardAllrLoader: false,
                acaDashboardAllrError: null
            }
        }
        case ACA_DASHBOARD_ALLR_ERROR: {
            return {
                ...state,
                acaDashboardAllrError: action.payload,
                acaDashboardAllrLoader: false
            }
        }
        default:
            return state;
    }
}